"use client"

import React, {PropsWithChildren} from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Arrow from "@/assets/svg/ArrowSlider"
import ArrowMobile from "@/assets/svg/ArrowSliderMobile"

interface I {
  title?: string
  slideNum: number
  length?: number
  infinite?: boolean
  classNames?: string
  centerPadding?: string
  withArrows?: boolean
  centerMode?: boolean
  rows?: number
  onlyImage?: boolean
}

interface Arrow {
  style?: React.CSSProperties
  onClick?: () => void
}

const ArrowNext: React.FC<Arrow> = ({style, onClick}) => (
  <div className="absolute z-50 sm:w-[44px] sm:h-[44px] sm:-bottom-12 sm:right-[35%] sm:top-auto sm:my-0 top-0 bottom-0 my-auto right-10 rotate-180 scale-x-[-1] w-10 h-10 transition cursor-pointer"
       style={style}
       onClick={onClick}
  >
    <ArrowMobile className="sm:block hidden"/>
    <Arrow className="sm:hidden"/>
  </div>
)

const ArrowPrev: React.FC<Arrow> = ({style, onClick}) => (
  <div className="absolute z-50 sm:w-[44px] sm:h-[44px] sm:-bottom-12 sm:left-[35%] sm:top-auto sm:my-0 top-0 bottom-0 my-auto left-10 scale-x-[-1] w-10 h-10 transition cursor-pointer"
       style={style}
       onClick={onClick}
  >
    <ArrowMobile className="sm:block hidden"/>
    <Arrow className="sm:hidden"/>
  </div>
)

const SliderWithArrows: React.FC<PropsWithChildren<I>> = ({
  title,
  slideNum,
  infinite,
  children,
  rows = 1,
  classNames,
  centerPadding,
  centerMode,
  withArrows = false,
  length,
  onlyImage
}) => {

  const settings = {
    infinite: !!infinite,
    speed: 500,
    slidesToShow: slideNum,
    slidesToScroll: 1,
    rows: rows,
    variableWidth: onlyImage || false,
    centerMode: centerMode,
    centerPadding: centerPadding,
    className: `w-full ${classNames}`,
    prevArrow: withArrows ? <ArrowPrev/> : <></>,
    nextArrow: withArrows ? <ArrowNext/> : <></>
  }

  const getEmptyArray = (num: number) => {
    const content = []
    for (let i = num; i > 0; i--) {
      content.push(<div key={i}></div>)
    }
    return content
  }

  return (
    <div className="relative h-full">
      {title && (
        <div className="flex justify-between pb-2">
          <h4>{title}</h4>
        </div>
      )}
      <Slider {...settings}>
        {children}
        {length && slideNum * rows - length > 0 && getEmptyArray(slideNum * rows - length)}
      </Slider>
    </div>
  )
}

export default SliderWithArrows
